"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _AccountSearch = _interopRequireDefault(require("../AccountSearch"));
require("./SearchBar.less");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SearchBar = function SearchBar(_ref) {
  var _ref$isAdmin = _ref.isAdmin,
    isAdmin = _ref$isAdmin === void 0 ? false : _ref$isAdmin;
  if (isAdmin) {
    return /*#__PURE__*/_react.default.createElement(_AccountSearch.default, null);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "patient-search-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_AccountSearch.default, null));
};
var _default = SearchBar;
exports.default = _default;